import { z } from 'zod'
import type { FinancialTransaction, TransactionCategory, PaymentMethod } from '@/types'

export const CATEGORY_OPTIONS: TransactionCategory[] = [
  'PATIENT_FEE',
  'SALARY',
  'UTILITIES',
  'SUPPLIES',
  'MAINTENANCE',
  'GOVERNMENT_FUNDING',
  'OTHER',
]

export const PAYMENT_METHOD_OPTIONS: PaymentMethod[] = ['CASH', 'BANK_TRANSFER', 'CARD', 'OTHER']

export const editTransactionSchema = z.object({
  transactionType: z.enum(['INCOME', 'EXPENSE'], {
    message: 'financials:form.errors.typeRequired',
  }),
  amount: z
    .string()
    .min(1, 'financials:form.errors.amountRequired')
    .refine((val) => !isNaN(Number(val)) && Number(val) > 0, {
      message: 'financials:form.errors.amountPositive',
    }),
  category: z.enum(
    [
      'PATIENT_FEE',
      'SALARY',
      'UTILITIES',
      'SUPPLIES',
      'MAINTENANCE',
      'GOVERNMENT_FUNDING',
      'OTHER',
    ],
    { message: 'financials:form.errors.categoryRequired' }
  ),
  description: z.string().min(1, 'financials:form.errors.descriptionRequired').max(500),
  transactionDate: z.string().min(1, 'financials:form.errors.dateRequired'),
  patientId: z.string().optional().or(z.literal('')),
  paymentMethod: z.enum(['CASH', 'BANK_TRANSFER', 'CARD', 'OTHER']),
  referenceNumber: z.string().optional().or(z.literal('')),
})

export type EditTransactionFormValues = z.infer<typeof editTransactionSchema>

export function getEditDefaultValues(tx: FinancialTransaction): EditTransactionFormValues {
  return {
    transactionType: tx.transactionType,
    amount: (tx.amountCents / 100).toFixed(2),
    category: tx.category,
    description: tx.description,
    transactionDate: new Date(tx.transactionDate).toISOString().split('T')[0],
    patientId: tx.patientId ?? '',
    paymentMethod: tx.paymentMethod,
    referenceNumber: tx.referenceNumber ?? '',
  }
}
